var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"incoming-campaigns"},[_c('page-title',{staticClass:"mb-4",attrs:{"title":_vm.$t('my_campaigns')}}),_c('div',{staticClass:"page-content"},[_c('my-campaigns-tabs')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }